// Lives in its own file (not inline in organizationFeature.ts) so route
// factories and screens can import these constants without a circular import
// back through organizationFeature.ts -> presentation/routes -> here.
const COMPANIES_LIST = "core.organization_management.organization_management_list";
const ADMINS_LIST = "core.organization_management.account_admin_management_list";
const REGIONS_LIST = "core.organization_management.region_management_list";
const BRANCHES_LIST = "core.organization_management.branch_management_list";
const DEPARTMENTS_LIST = "core.organization_management.department_management_list";
// Not in the contract yet -- mirrors regions/branches/departments as a
// permission-grantable placeholder (see IndividualsListScreen).
const INDIVIDUALS_LIST = "core.organization_management.individual_management_list";

export const COMPANIES_VIEW = `${COMPANIES_LIST}.view`;
export const COMPANIES_CREATE = `${COMPANIES_LIST}.create`;
export const COMPANIES_UPDATE = `${COMPANIES_LIST}.update`;
export const COMPANIES_DELETE = `${COMPANIES_LIST}.delete`;

export const ADMINS_VIEW = `${ADMINS_LIST}.view`;
export const ADMINS_CREATE = `${ADMINS_LIST}.create`;
export const ADMINS_UPDATE = `${ADMINS_LIST}.update`;
export const ADMINS_DELETE = `${ADMINS_LIST}.delete`;

export const REGIONS_VIEW = `${REGIONS_LIST}.view`;
export const REGIONS_CREATE = `${REGIONS_LIST}.create`;
export const REGIONS_UPDATE = `${REGIONS_LIST}.update`;
export const REGIONS_DELETE = `${REGIONS_LIST}.delete`;

export const BRANCHES_VIEW = `${BRANCHES_LIST}.view`;
export const BRANCHES_CREATE = `${BRANCHES_LIST}.create`;
export const BRANCHES_UPDATE = `${BRANCHES_LIST}.update`;
export const BRANCHES_DELETE = `${BRANCHES_LIST}.delete`;

export const DEPARTMENTS_VIEW = `${DEPARTMENTS_LIST}.view`;
export const DEPARTMENTS_CREATE = `${DEPARTMENTS_LIST}.create`;
export const DEPARTMENTS_UPDATE = `${DEPARTMENTS_LIST}.update`;
export const DEPARTMENTS_DELETE = `${DEPARTMENTS_LIST}.delete`;

export const INDIVIDUALS_VIEW = `${INDIVIDUALS_LIST}.view`;
export const INDIVIDUALS_CREATE = `${INDIVIDUALS_LIST}.create`;
export const INDIVIDUALS_UPDATE = `${INDIVIDUALS_LIST}.update`;
export const INDIVIDUALS_DELETE = `${INDIVIDUALS_LIST}.delete`;
